import { useState } from 'react';
import { IInstitution } from './accountTypeData';

const useInstitutionSelection = () => {
  const [selected, setSelected] = useState<IInstitution | null>(null);

  const updateSelected = (institution: IInstitution | null) => {
    setSelected(institution);
  };

  return {
    selected,
    updateSelected,
  };
};

export default useInstitutionSelection;
